function getMonthPrice(yearPrice) {
  return yearPrice / 12;
}
function fixPrice(price) {
  return Number(price.toFixed(2))
}

export const priceMixin = {
  methods: {
    _caclPrice(monthDuration, order) {
      let totalMonth = monthDuration + order.usedMonthNum + order.rentFreeDuration;
      let usedMonth = order.usedMonthNum + order.rentFreeDuration;
      if(totalMonth > 0 && totalMonth <= 12) {
        return this._caclFirstMonthPrice(monthDuration, order);
      } else if (totalMonth <= 24 && totalMonth > 12) {
        return this._caclSecondYearPrice(totalMonth, usedMonth, order);
      } else if (totalMonth <= 36 && totalMonth > 24) {
        return this._caclThirdYearPrice(totalMonth, usedMonth, order);
      } else {
        return 0;
      }
    },
    _caclFirstMonthPrice(monthDuration, {firstYearPrice = 0}) {
      return fixPrice(monthDuration * getMonthPrice(firstYearPrice));
    },
    _caclSecondYearPrice(totalMonth, usedMonth, {firstYearPrice = 0, secondYearPrice = 0}) {
      if(usedMonth <= 12) {
        return fixPrice((12 - usedMonth) * getMonthPrice(firstYearPrice)) + fixPrice((totalMonth - 12) * getMonthPrice(secondYearPrice));
      } else {
        return fixPrice((totalMonth - usedMonth) * getMonthPrice(secondYearPrice));
      }
    },
    _caclThirdYearPrice(totalMonth, usedMonth, {firstYearPrice = 0, secondYearPrice = 0, thirdYearPrice = 0}) {
      if(usedMonth <= 12) {
        return fixPrice((12 - usedMonth) * getMonthPrice(firstYearPrice)) + fixPrice(12 * getMonthPrice(secondYearPrice)) + fixPrice((totalMonth - 24) * getMonthPrice(thirdYearPrice));
      } else if (usedMonth > 12 && usedMonth <= 24) {
        return fixPrice((24 - usedMonth) * getMonthPrice(secondYearPrice)) + fixPrice((totalMonth - 24) * getMonthPrice(thirdYearPrice));
      } else if (usedMonth > 24 && usedMonth <= 36) {
        return fixPrice((totalMonth - usedMonth) * getMonthPrice(thirdYearPrice));
      }
    }
  }
}